document.addEventListener('DOMContentLoaded', () => {
    initParticles();
    initScrollAnimations();
});

function initParticles() {
    const container = document.querySelector('.spectacular-particles');
    if (!container) return;

    const particleCount = 30;
    const colors = ['#ffffff', '#00d4ff', '#00ff88'];

    for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement('div');
        particle.classList.add('particle');

        // Random properties
        const size = Math.random() * 15 + 5;
        const left = Math.random() * 100;
        const top = Math.random() * 100;
        const delay = Math.random() * 15;
        const duration = Math.random() * 10 + 10;
        const color = colors[Math.floor(Math.random() * colors.length)];

        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        particle.style.left = `${left}%`;
        particle.style.top = `${top}%`;
        particle.style.animationDelay = `-${delay}s`;
        particle.style.animationDuration = `${duration}s`;
        particle.style.background = color;

        container.appendChild(particle);
    }
}

function initScrollAnimations() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-in');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    const elements = document.querySelectorAll('.spectacular-title, .spectacular-eyebrow, .glass-card, .glass-panel');
    elements.forEach(el => observer.observe(el));
}
